import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["checked", "id", "name", "disabled"]
const _hoisted_2 = ["for"]

import { ref, onMounted, computed } from "vue"

interface Props {
    modelValue?: boolean | null
    label?: string
    name?: string
    checked?: boolean
    indeterminate?: boolean
    classes?: string[]
    disabled?: boolean
    isLabelClickable?: boolean
    centered?: boolean
    labelClasses?: string[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GgmsCheckBox',
  props: {
    modelValue: { type: [Boolean, null], default: false },
    label: {},
    name: {},
    checked: { type: Boolean },
    indeterminate: { type: Boolean },
    classes: { default: () => [] },
    disabled: { type: Boolean },
    isLabelClickable: { type: Boolean },
    centered: { type: Boolean, default: true },
    labelClasses: { default: () => [] }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const props = __props

const checkBox = ref()

const disabledStyle = computed(() => ({
    "cursor-not-allowed": props.disabled,
    "opacity-70": props.disabled,
}))

const style = computed(() => [props.centered ? "items-center" : "", "flex w-fit cursor-pointer", disabledStyle.value])

const isLabelClickable = computed(() => ({
    "pointer-events-none": props.isLabelClickable,
    "cursor-default": props.isLabelClickable,
}))

function onInput() {
    if (props.disabled) return
    if (props.indeterminate) {
        switch (props.modelValue) {
            case null:
                emits("update:modelValue", true)
                break
            case true:
                emits("update:modelValue", false)
                break
            case false:
                checkBox.value.indeterminate = true
                emits("update:modelValue", null)
                break
        }
    } else {
        emits("update:modelValue", !props.modelValue)
    }
}

onMounted(() => {
    if (props.modelValue === null && props.indeterminate) {
        checkBox.value.indeterminate = true
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(style.value),
    onClick: onInput
  }, [
    _createElementVNode("input", {
      ref_key: "checkBox",
      ref: checkBox,
      checked: _ctx.modelValue || _ctx.checked,
      id: _ctx.name,
      name: _ctx.name,
      type: "checkbox",
      disabled: _ctx.disabled,
      class: _normalizeClass(["h-4 w-4 text-primary-color-600 focus:ring-primary-color-500 border-gray-300 rounded cursor-pointer", [..._ctx.classes, disabledStyle.value]])
    }, null, 10, _hoisted_1),
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _ctx.name,
          class: _normalizeClass(["ml-3 block text-sm text-gray-900 cursor-pointer", [..._ctx.labelClasses, disabledStyle.value, isLabelClickable.value]])
        }, _toDisplayString(_ctx.label), 11, _hoisted_2))
      : _renderSlot(_ctx.$slots, "default", {
          key: 1,
          for: _ctx.name
        })
  ], 2))
}
}

})